import { type StateCreator } from 'zustand';

type SetSubSideNavBrowseLastPathParams = {
  path: string;
  workspaceId: string;
};

export type SubSideNavBrowseLastPathSlice = {
  lastPathByWorkspaceId: Record<string, string>;
  setLastPath: (params: SetSubSideNavBrowseLastPathParams) => void;
};

export type CreateSubSideNavBrowseLastPathSlice = (
  initialState: Pick<Partial<SubSideNavBrowseLastPathSlice>, 'lastPathByWorkspaceId'>,
) => StateCreator<SubSideNavBrowseLastPathSlice, [], [], SubSideNavBrowseLastPathSlice>;

export const createSubSideNavBrowseLastPathSlice: CreateSubSideNavBrowseLastPathSlice = (initialState) => (set) => ({
  lastPathByWorkspaceId: initialState.lastPathByWorkspaceId ?? {},
  setLastPath: ({ path, workspaceId }) =>
    set((state) => ({
      lastPathByWorkspaceId: {
        ...state.lastPathByWorkspaceId,
        [workspaceId]: path,
      },
    })),
});
